
import Container from '../../components/form/container/Container.vue'
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import {
  exportVoucherTemplate, getPaymentSlipHistoryCashDetail, getRelatedPaymentSlipPageList
} from '@/apis/paymentSlip/paymentSlipHistory'
import { PaymentSlipHistoryModel, RelatedPaymentSlipPageParamModel } from '@/model/paymentSlip/paymentSlipHistoryModel'
import { formatDate, formatThousands } from '@/utils'
import { ElMessage } from 'element-plus'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import { PaymentSlipModel } from '@/model/paymentSlip/paymentSlipModel'

export default defineComponent({
  name: 'PaymentSlipHistoryCashDetail',
  methods: { formatThousands },
  props: {
    inputData: {
      type: Object,
      required: true,
      default: null
    },
    labelWidth: {
      type: String,
      default: '680px'
    }
  },
  components: {
    SimpleTable,
    Container
  },
  setup() {
    const { t } = useI18n()
    const id = useRoute().params.id.toString()
    const paymentSlipTableStruct = [
      { prop: 'id', label: t('pay.id') },
      { prop: 'companyCode', label: t('company.companyCode') },
      { prop: 'payee', label: t('pay.payee') },
      { prop: 'reference', label: t('pay.reference') },
      { prop: 'amount', label: t('pay.amount'), formatter: (row: any) => formatThousands(row.amount), align: 'right' },
      { prop: 'currency', label: t('pay.currency') },
      { prop: 'dueDate', label: t('order.cutOffDate'), formatter: (row: any) => formatDate(row.dueDate, 'yyyy-MM-dd') },
      { prop: 'comments', label: t('pay.comments') },
      {
        prop: 'paymentDate',
        label: t('pay.paymentDate'),
        formatter: (row: any) => formatDate(row.paymentDate, 'yyyy-MM-dd')
      },
      { prop: 'purpose', label: t('pay.purposeView'), width: 170 }
    ]
    const dataMap = reactive({
      detailData: {} as PaymentSlipHistoryModel | null,
      paymentDate: '',
      tableData: Array<PaymentSlipModel>(),
      columnStruct: paymentSlipTableStruct,
      listLoading: true,
      limit: 10,
      total: 0,
      page: 1,
      async getData() {
        dataMap.listLoading = true
        const data = await getPaymentSlipHistoryCashDetail(id)
        if (data && data.data) {
          dataMap.detailData = data.data
        }
        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      paymentDateFormat(paymentDate: Date): string {
        return formatDate(paymentDate, 'yyyy-MM-dd')
      },
      handleCurrentChange(page?: any) {
        dataMap.getPageList(page)
      },
      handleSizeChange(val: any) {
        dataMap.getPageList(null, val)
      },
      async getPageList(page?: any, limit?: any) {
        if (page) {
          dataMap.page = page
        }
        if (limit) {
          dataMap.limit = limit
        }
        dataMap.listLoading = true
        let historyId
        try {
          historyId = Number(id)
        } catch (error) {
          ElMessage({
            message: 'id 格式错误;' + id,
            type: 'error',
            duration: 2000
          })
          return
        }
        const params: RelatedPaymentSlipPageParamModel = {
          id: historyId,
          pageCurrent: dataMap.page,
          pageSize: dataMap.limit
        }
        const data = await getRelatedPaymentSlipPageList(params)
        if (data && data.data && data.data.list.length > 0) {
          dataMap.tableData = data.data.list
        } else {
          dataMap.tableData = []
        }
        dataMap.total = data?.data.totalCount ?? 0
        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      }
    })
    const DownloadCertificateClick = async() => {
      if (dataMap.detailData && dataMap.detailData.paymentVoucher) {
        const formData = new FormData() as any
        formData.append('voucher', dataMap.detailData.paymentVoucher)
        const urlBlob = await exportVoucherTemplate(formData)
        if (urlBlob) {
          const link = document.createElement('a')
          link.href = urlBlob
          link.download = dataMap.detailData.paymentVoucher
          link.click()
          window.URL.revokeObjectURL(urlBlob)
        } else {
          ElMessage({
            message: '获取文件失败',
            type: 'error',
            duration: 2000
          })
        }
      } else {
        ElMessage({
          message: t('pay.paymentVoucherIsNull'),
          type: 'error',
          duration: 2000
        })
      }
    }
    onMounted(() => {
      dataMap.getData()
      dataMap.getPageList(null, 10)
    })
    return {
      t,
      DownloadCertificateClick,
      ...toRefs(dataMap)
    }
  }
})
